const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoSantander(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#ea1d25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.19,8.69c-.02-.36-.11-.81-.29-1.12l-1.55-2.87c-.12-.22-.2-.45-.25-.7l-.07.12c-.39.7-.39,1.59,0,2.29l1.26,2.29c.39.7.39,1.59,0,2.29l-.07.12c-.05-.24-.13-.48-.25-.7l-1.14-2.1-.73-1.35c-.12-.22-.2-.45-.25-.7l-.07.12c-.39.7-.39,1.57,0,2.29l1.26,2.29c.39.7.39,1.59,0,2.29l-.07.12c-.05-.24-.13-.48-.25-.7l-1.58-2.87c-.21-.39-.32-.69-.32-1.12-1.67.46-2.81,1.31-2.81,2.44,0,1.59,2.24,2.87,5,2.87s5-1.28,5-2.87c.02-1.08-1.12-1.99-2.81-2.44Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoSantander);
export default __webpack_public_path__ + "static/media/banco-santander.b2bfbb568d8be976144a595950156a73.svg";
export { ForwardRef as ReactComponent };